import { render, staticRenderFns } from "./HeaderCartButton.vue?vue&type=template&id=51aaef05&scoped=true"
import script from "./HeaderCartButton.vue?vue&type=script&lang=js"
export * from "./HeaderCartButton.vue?vue&type=script&lang=js"
import style0 from "./HeaderCartButton.vue?vue&type=style&index=0&id=51aaef05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aaef05",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fheader-cart-button%2FHeaderCartButton.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports